<template>
    <div>
        <st-divider class="auth-title" :between="3.4">
            <div>새로운 비밀번호가 필요합니다.</div>
            <div>비밀번호를 설정해주세요.</div>
        </st-divider>
        <st-divider>
            <st-input
                v-model="password"
                type="password"
                :width="37.5"
                placeholder="비밀번호를 입력해주세요."
                @enter="next"
            />
        </st-divider>
        <st-divider>
            <st-input
                v-model="password_confirm"
                ref="passwordConfirm"
                type="password"
                :width="37.5"
                placeholder="비밀번호를 한번 더 입력해주세요."
                @enter="submitHandler"
            />

            <div class="error-text">
                <span v-show="confirm">
                    <awesome-icon name="exclamation-circle" />비밀번호가 서로 다릅니다. 다시 한번 확인해주세요.
                </span>
            </div>
        </st-divider>
        <st-divider class="auto-login-checkbox" :between="3">
            <st-checkbox v-model="auto" @change="isCheckedAlertHandler" @enter="submitHandler">
                자동 로그인
            </st-checkbox>
        </st-divider>
        <st-divider :between="4">
            <st-button :width="27.5" color="primary" :disabled="disabled" @click="submitHandler">
                비밀번호 설정하기
            </st-button>
        </st-divider>
        <div class="auth-waring">
            * 다음 이용시 인증절차 없이 비밀번호로 로그인 가능합니다.<br />
            * 비밀번호 설정 후 로그인이 바로 진행됩니다.
        </div>
    </div>
</template>
<script>
import { dataEncoded } from "../../../utils/lib";
export default {
    name: "AuthConfigPassword",
    data: () => ({
        password: null,
        password_confirm: null,
        loading: false,
        auto: false
    }),
    props: {
        phone: String,
        token: String
    },
    computed: {
        confirm() {
            if (!this.password || !this.password_confirm) return false; // 둘중에 하나라도 없으면 보여주지 않기
            if (this.password !== this.password_confirm) return true; // 둘이 값이 다르면 에러
            return false; // 둘다 값이 있고 같으면 통과
        },
        disabled() {
            return !this.password || !this.password_confirm || this.confirm || this.loading;
        }
    },
    methods: {
        loadingToggle() {
            this.loading = !this.loading;
        },

        isCheckedAlertHandler({ value }) {
            if (value) this.$alert("info", "자동로그인을 설정하셨습니다.");
        },

        async submitHandler() {
            this.loadingToggle();

            const data = dataEncoded({
                password: this.password,
                passwordConfirm: this.password_confirm,
                token: this.token
            });

            try {
                const response = await this.$api.user.makePassword(data);

                this.$alert("success", "비밀번호 설정이 완료되었습니다.");
                // this.$emit("push-page", "pw-login");

                // 비밀번호 설정이 끝나면 바로 로그인 진행
                this.loginHandler();
            } catch (e) {
                this.loadingToggle();
                this.$alert("error", e.message);
            }
        },

        async loginHandler() {
            const data = dataEncoded({ phoneNumber: this.phone, password: this.password });

            try {
                const response = await this.$api.user.authPassword(data);
                this.$emit("login", { ...response.data, auto: this.auto, hooks: this.loadingToggle });
            } catch (e) {
                this.loadingToggle();
                this.$alert("error", e.message);
            }
        },

        next() {
            if (!this.password) {
                this.$alert("error", "비밀번호를 입력해주세요.");
                return;
            }

            this.$refs.passwordConfirm.focus();
        }
    }
};
</script>
